import { useState } from 'react';

import CustomModal from '@/components/CustomModal';
import { RadioButtonGroup } from '@/components/RadioButton';
import { STATUS_OPTIONS, LINKED_CHILDREN_OPTIONS } from '@/constants/constant';
import { ERoleAccess } from '@/enum';
import useAccess from '@/hooks/useAccess';
import { useFormatText } from '@/hooks/useFormatText';
import { IParentFilterValues } from '@/types';

const ParentFilterModal = ({
  setIsOpen,
  onApply,
  initialValues = {},
}: {
  setIsOpen: (open: boolean) => void;
  onApply: (filters: IParentFilterValues) => void;
  initialValues?: Partial<IParentFilterValues>;
}) => {
  const { hasAccess } = useAccess();

  const { formatText } = useFormatText();
  const [status, setStatus] = useState(initialValues.status || '');
  const [linkedChildren, setLinkedChildren] = useState(
    initialValues.linkedChildren || ''
  );

  const handleClear = () => {
    setStatus('');
    setLinkedChildren('');
    onApply({ status: '', linkedChildren: '' });
    setIsOpen(false);
  };

  const handleApply = () => {
    onApply({ status, linkedChildren });
    setIsOpen(false);
  };

  if (!hasAccess(ERoleAccess.USER_MANAGEMENT)) return null;

  return (
    <CustomModal
      setIsOpen={setIsOpen}
      isHeader
      isFooter
      heading={formatText('common.actions.filter')}
      position="right"
      className="max-w-150"
      confirmButtonProps={{
        label: formatText('common.actions.show-results'),
        variant: 'primary',
        onClick: handleApply,
        disabled: !status && !linkedChildren,
      }}
      cancelButtonProps={{
        label: formatText('common.actions.clear-filters'),
        desructive: true,
        onClick: handleClear,
        className: 'text-sm underline px-0!',
      }}
    >
      <div className="flex flex-col gap-6 w-full">
        {/* Status */}
        <RadioButtonGroup
          name="status"
          label={formatText('user-management.status')}
          options={STATUS_OPTIONS}
          value={status}
          onChange={setStatus}
          formatLabel={formatText}
        />
        {/* Linked Children */}
        <RadioButtonGroup
          name="linkedChildren"
          label={formatText('parent.columns.linked-children')}
          options={LINKED_CHILDREN_OPTIONS}
          value={linkedChildren}
          onChange={setLinkedChildren}
        />
      </div>
    </CustomModal>
  );
};

export default ParentFilterModal;
